import { RefObject } from 'react'

import * as S from './styles'
import { useTeamNataContainer } from './useTeamNataContainer'
import { FormContainer } from '../formContainer'
import { NhShape } from '@/assets/imgs'
import { Image, TextWithHighlighted } from '@/components'
import { useIsVisibleElement } from '@/hooks/useIsVisibleElement'

export type TeamNataContainerProps = {
  element: RefObject<HTMLDivElement>
}
export const TeamNataContainer: React.FC<TeamNataContainerProps> = ({
  element,
}) => {
  const { teamNataData } = useTeamNataContainer()
  const { element: formElement, elementVisible } = useIsVisibleElement(true)

  return (
    <S.TeamNataContainer ref={element}>
      <TextWithHighlighted
        size="h3"
        align="center"
        className="title"
        text={teamNataData.title}
      />

      <div className="logo-form" ref={formElement}>
        <Image src={NhShape} alt="logo nata" />
        <FormContainer
          title={teamNataData.formTitle}
          nameInputLabel={teamNataData.nameInputLabel}
          nameInputPlaceholder={teamNataData.nameInputPlaceholder}
          emailInputLabel={teamNataData.emailInputLabel}
          emailInputPlaceholder={teamNataData.emailInputPlaceholder}
          phoneInputLabel={teamNataData.phoneInputLabel}
          phoneInputPlaceholder={teamNataData.phoneInputPlaceholder}
          buttonText={teamNataData.buttonText}
          buttonTextSuccess={teamNataData.buttonTextSuccess}
          elementVisible={elementVisible}
        />
      </div>
    </S.TeamNataContainer>
  )
}
